import { Form, Modal, Spin } from 'antd'
import React from 'react'
import '../../assets/styles/scss/pages/_login.scss'
import FormSignOut from './form-signOut'
import FormSignIn from './form-signIn'
import FormOtp from './form-otp'

const LoginModal = ({ props }) => {
    const {
        openModalLogin,
        setOpenModalLogin,
        form,
        onFinish,
        onFinishFailed,
        userData,
        handleLogin,
        handleLogOut,
        loadingModal = false,
        isShowOtp = false,
        onOkLogOut
    } = props

    return (
        <div className='login-modal'>
            <Modal
                centered
                footer={false}
                open={openModalLogin}
                closable={false}
                onOk={() => setOpenModalLogin(false)}
                onCancel={() => setOpenModalLogin(false)}
                width={350}
                className='modal-login'
            >
                <Spin tip="Loading..." spinning={loadingModal}>
                    <Form
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        form={form}
                        className="relative login-form-modal"
                        layout="vertical"
                    >
                        {isShowOtp ? <FormOtp props={props} />
                            :
                            <>
                                {userData && userData.isLoggedIn === true ?
                                    <FormSignOut userData={userData} handleLogOut={handleLogOut} onOkLogOut={onOkLogOut} setOpenModalLogin={setOpenModalLogin} />
                                    :
                                    <FormSignIn handleLogin={handleLogin} />}
                            </>}
                    </Form>
                </Spin>
            </Modal>
        </div>
    )
}

export default LoginModal